module.exports = __webpack_public_path__ + "img/Regenbogen.f7b362a3.svg";